import { isPurchasingSubscription } from 'src/data/subscription';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useHasActivePaidSubscription = () => {
  const currentCustomer = useCurrentCustomer();
  return !isPurchasingSubscription(currentCustomer);
};
